import * as React from "react";

import { RouteComponentProps, withRouter } from "react-router";

class ScrollToTop extends React.Component<RouteComponentProps> {
    public componentDidUpdate(prevProps: RouteComponentProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            const rootElement = document.getElementById("root");
            if (rootElement) {
                rootElement!.scrollTop = 0;
            }
        }
    }

    public render() {
        return this.props.children;
    }
}

export default withRouter(ScrollToTop);
